import React from 'react'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  styled,
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { BillingHistorySummaryTableVariant } from './BillingHistorySummaryTable'
import { LicensingBill } from '../../../swagger'
import { dateToSlashStringReinterpretedAsLocal } from '../../../utils/dateUtility'
import ProgramLicensingInformation from './ProgramLicensingInformation'

const StyledAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
  [theme.breakpoints.down('xs')]: {
    flexDirection: 'column',
    alignItems: 'center',
    marginLeft: 'unset',
  },
}))

interface ProgramLicensingInformationAccordionProps {
  licensingBill: LicensingBill
  achDiscount: string
  triggerRefetch: () => void
  disableMakeAPayment: boolean
  isViewingRoleBillingHistory: boolean
  disableShowDetails?: boolean
  variantForBillingHistorySummaryTable?: BillingHistorySummaryTableVariant
  achAllowed: boolean
}

const ProgramLicensingInformationAccordion: React.FC<
  ProgramLicensingInformationAccordionProps
> = ({
  licensingBill,
  achDiscount,
  triggerRefetch,
  disableMakeAPayment,
  isViewingRoleBillingHistory,
  disableShowDetails,
  variantForBillingHistorySummaryTable,
  achAllowed,
}) => {
  return (
    <Accordion TransitionProps={{ unmountOnExit: true }}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="accordion-content"
        id="accordion-header"
      >
        <Typography variant="button" component="p">
          {`${licensingBill._for.programType} (${
            licensingBill._for.semesterOneStartDate
              ? dateToSlashStringReinterpretedAsLocal(
                  licensingBill._for.semesterOneStartDate as Date
                )
              : ''
          }) - ${licensingBill._for.communityName}`}
        </Typography>
      </AccordionSummary>
      <StyledAccordionDetails>
        <ProgramLicensingInformation
          header=""
          hideHeaderLeft
          program={licensingBill}
          achDiscount={achDiscount}
          refetch={triggerRefetch}
          disableMakeAPayment={disableMakeAPayment}
          hideMakeAPaymentButton={isViewingRoleBillingHistory}
          disableShowDetails={disableShowDetails}
          variant={variantForBillingHistorySummaryTable}
          achAllowed={achAllowed}
          isLcd={
            licensingBill._for.programDirectorRole ===
            'Licensed Community Director'
          }
        />
      </StyledAccordionDetails>
    </Accordion>
  )
}

export default ProgramLicensingInformationAccordion
